import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { AvatarInfo, AppDrawer } from "components";
import { KeyConstant, LangConstant, SystemConstant } from "const";
import { ConversationActions } from "redux-store";
import { StorageUtil } from "utils";
import { getSavedServer } from "utils/branch.utils";

const ChooseAdminDrawer = ({ open, dataAdmin, onClose, groupDetail }) => {
  const classes = useStyles();
  const { t: getLabel } = useTranslation(LangConstant.NS_HOME_CONVERSATION);
  const dispatch = useDispatch();

  const [admin, setAdmin] = useState({});

  let accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID);
  let savedServer = getSavedServer();

  const onChooseNewAdmin = item => {
    setAdmin(item);

    dispatch(
      ConversationActions.sendMessage({
        groupId: groupDetail.id,
        sendType: SystemConstant.SEND_TYPE.leaveGroup,
        content: accountId,
        parentId: null,
        deviceList: [],
        branchId: savedServer?.id,
        mentionIdsArr: [],
        threadId: null,
        removingId: accountId,
        adminId: admin.id,
      }),
    );

    onClose();
  };

  const arrayAdmin = (dataAdmin || []).filter(item => item.id !== accountId);

  return (
    <AppDrawer
      onClose={onClose}
      open={open}
      anchor={"right"}
      hideBackdrop={false}
      title={getLabel(LangConstant.TXT_CHOOSE_NEW_ADMIN)}
    >
      <Box className={classes.root}>
        <Box className={classes.memberList}>
          {arrayAdmin.map((item, index) => (
            <AvatarInfo
              key={`${item.avatarId}-${index}`}
              avatar={{ avatarId: item.avatarId, name: item.name }}
              title={item.name}
              onClick={() => onChooseNewAdmin(item)}
              button={true}
            />
          ))}
        </Box>
      </Box>
    </AppDrawer>
  );
};

ChooseAdminDrawer.propTypes = {};

export default ChooseAdminDrawer;

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },

  listTitle: {
    color: theme.palette.text.secondary,
    lineHeight: "1.25rem",
    padding: "0 16px",
  },
}));
